module.exports = __webpack_public_path__ + "static/media/placeholder-back-document.236df154.svg";